import type { TypeBloqueHProps } from '@/organisms/BloqueH';
import type { ElementType } from 'react';
import type { BloqueHGraphQL } from '../../types/flexible';

export const BloqueHTransformer = (
  bloque: BloqueHGraphQL,
): TypeBloqueHProps => ({
  ...(bloque.title && { title: bloque.title }),
  ...(bloque.description && { description: bloque.description }),
  ...(bloque.extendedText && { extendedText: bloque.extendedText }),
  titleType: bloque.titleType as ElementType<any>,
  ...(bloque.titleUppercase && { titleUppercase: true }),
  titleSize: bloque.titleSize,
  titleColor: bloque.titleColor,
  ...(bloque.maxWidthTitle && { maxWidthTitle: bloque.maxWidthTitle }),
  titleAlign: bloque.titleAlign,
  descriptionType: bloque.descriptionType as ElementType<any>,
  ...(bloque.descriptionUppercase && { descriptionUppercase: true }),
  descriptionSize: bloque.descriptionSize,
  descriptionColor: bloque.descriptionColor,
  ...(bloque.maxWidthDescription && {
    maxWidthDescription: bloque.maxWidthDescription,
  }),
  descriptionAlign: bloque.descriptionAlign,
});
